import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login.vue"),
  },
  {
    path: "/home",
    name: "home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home.vue"),
    redirect: "/home/index",
    children: [
      {
        path: "index",
        name: "index",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/index/index.vue"),
        meta: { requireAuth: true },
      },
      {
        path: "users",
        name: "users",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/users/list.vue"),
        meta: { requireAuth: true, name: "用户列表", comp: "users" },
      },
      {
        path: "roles",
        name: "roles",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/users/roles.vue"),
        meta: { requireAuth: true, name: "角色列表", comp: "roles" },
      },
      {
        path: "rebateMonitor",
        name: "rebateMonitor",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/users/rebateMonitor.vue"
          ),
        meta: {
          requireAuth: true,
          name: "返利标记用户数据列表",
          comp: "rebateMonitor",
        },
      },
      {
        path: "userDetails",
        name: "userDetails",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/users/userDetails.vue"
          ),
        meta: { requireAuth: true },
      },
      // 权限
      {
        path: "privilegeList",
        name: "privilegeList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/privilege/privilegeList.vue"
          ),
        meta: { requireAuth: true, name: "权限列表", comp: "privilegeList" },
      },
      {
        path: "privilegeAdd",
        name: "privilegeAdd",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/privilege/privilegeAdd.vue"
          ),
        meta: { requireAuth: true },
      },
      {
        path: "privilegeEdit",
        name: "privilegeEdit",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/privilege/privilegeEdit.vue"
          ),
        meta: { requireAuth: true },
      },
      {
        path: "orders",
        name: "orders",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/orders/orders.vue"),
        meta: { requireAuth: true, name: "订单列表", comp: "orders" },
      },
      {
        path: "games",
        name: "games",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/games/games.vue"),
        meta: { requireAuth: true, name: "游戏列表", comp: "games" },
      },
      {
        path: "gamePackage",
        name: "gamePackage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/games/gamePackage.vue"
          ),
        meta: { requireAuth: true, name: "游戏包列表", comp: "gamePackage" },
      },
      {
        path: "channel",
        name: "channel",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/channel/channel.vue"
          ),
        meta: { requireAuth: true, name: "渠道列表", comp: "channel" },
      },
      {
        path: "channelPackage",
        name: "channelPackage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/channel/channelPackage.vue"
          ),
        meta: { requireAuth: true, name: "渠道包列表", comp: "channelPackage" },
      },
      {
        path: "channelGroup",
        name: "channelGroup",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/manage/channelGroup.vue"
          ),
        meta: { requireAuth: true, name: "渠道包组列表", comp: "channelGroup" },
      },
      {
        path: "recharge",
        name: "recharge",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/recharge.vue"
          ),
        meta: { requireAuth: true, name: "充值排行榜", comp: "recharge" },
      },
      {
        path: "retention",
        name: "retention",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/retention.vue"
          ),
        meta: { requireAuth: true, name: "用户留存统计", comp: "retention" },
      },
      {
        path: "userRetention",
        name: "userRetention",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/userRetention.vue"
          ),
        meta: {
          requireAuth: true,
          name: "用户付费留存统计",
          comp: "userRetention",
        },
      },
      {
        path: "ltv",
        name: "ltv",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/statistics/ltv.vue"),
        meta: { requireAuth: true, name: "用户生命周期LTV", comp: "ltv" },
      },
      {
        path: "report",
        name: "report",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/report.vue"
          ),
        meta: { requireAuth: true, name: "总数据报表统计", comp: "report" },
      },
      {
        path: "channelReport",
        name: "channelReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/channelReport.vue"
          ),
        meta: { requireAuth: true, name: "渠道包数据报表统计", comp: "channelReport" },
      },
      {
        path: "areaReport",
        name: "areaReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/areaReport.vue"
          ),
        meta: { requireAuth: true, name: "游戏区服报表统计", comp: "areaReport" },
      },
      {
        path: "monthSummary",
        name: "monthSummary",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/monthSummary.vue"
          ),
        meta: { requireAuth: true, name: "每月数据汇总", comp: "monthSummary" },
      },
      {
        path: "hourDataReport",
        name: "hourDataReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/hourDataReport.vue"
          ),
        meta: {
          requireAuth: true,
          name: "分时数据统计",
          comp: "hourDataReport",
        },
      },
      {
        path: "blackIp",
        name: "blackIp",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/black/blackIp.vue"),
        meta: { requireAuth: true, name: "IP黑名单", comp: "blackIp" },
      },
      {
        path: "blackPhone",
        name: "blackPhone",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/black/blackPhone.vue"
          ),
        meta: { requireAuth: true, name: "手机黑名单", comp: "blackPhone" },
      },
      {
        path: "blackGdids",
        name: "blackGdids",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/black/blackGdids.vue"
          ),
        meta: { requireAuth: true, name: "设备号黑名单", comp: "blackGdids" },
      },
      {
        path: "blackUser",
        name: "blackUser",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/black/blackUser.vue"
          ),
        meta: { requireAuth: true, name: "用户黑名单", comp: "blackUser" },
      },
      // 白名单--手机白名单
      {
        path: "whitePhone",
        name: "whitePhone",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/white/whitePhone.vue"
          ),
        meta: { requireAuth: true, name: "手机白名单", comp: "whitePhone" },
      },
      // 白名单--用户白名单
      {
        path: "whiteUser",
        name: "whiteUser",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/white/whiteUser.vue"
          ),
        meta: { requireAuth: true, name: "用户白名单", comp: "whiteUser" },
      },
      // 白名单--设备白名单
      {
        path: "whiteGdids",
        name: "whiteGdids",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/white/whiteGdids.vue"
          ),
        meta: { requireAuth: true, name: "设备白名单", comp: "whiteGdids" },
      },
      // 白名单--身份证白名单
      {
        path: "whiteIdNumber",
        name: "whiteIdNumber",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/white/whiteIdNumber.vue"
          ),
        meta: { requireAuth: true, name: "身份证白名单", comp: "whiteIdNumber" },
      },
      // 白名单--身份证白名单
      {
        path: "whiteIp",
        name: "whiteIp",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/white/whiteIp.vue"
          ),
        meta: { requireAuth: true, name: "IP白名单", comp: "whiteIp" },
      },
      // 预付池
      {
        path: "prepaidPool",
        name: "prepaidPool",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/pool/prepaidPool.vue"
          ),
        meta: { requireAuth: true, name: "预付池", comp: "prepaidPool" },
      },
      // 返还审核
      {
        path: "backExamine",
        name: "backExamine",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/pool/backExamine.vue"
          ),
        meta: { requireAuth: true, name: "返还审核", comp: "backExamine" },
      },
      // 周期统计
      // 留存统计
       {
        path: "retainCycleStatistics",
        name: "retainCycleStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/retainCycleStatistics.vue"
          ),
        meta: { requireAuth: true, name: "留存统计", comp: "retainCycleStatistics" },
      },
      {
        path: "ltvCycleStatistics",
        name: "ltvCycleStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/ltvCycleStatistics.vue"
          ),
        meta: { requireAuth: true, name: "LTV统计", comp: "ltvCycleStatistics" },
      },
      // 商品出售统计汇总（周期）
      {
        path: "goodsStatisticsCycle",
        name: "goodsStatisticsCycle",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/goodsStatisticsCycle.vue"
          ),
        meta: { requireAuth: true, name: "商品周期统计", comp: "goodsStatisticsCycle" },
      },
      // 商品出售统计汇总（汇总）
      {
        path: "goodsStatisticalSummary",
        name: "goodsStatisticalSummary",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/goodsStatisticalSummary.vue"
          ),
        meta: { requireAuth: true, name: "商品汇总统计", comp: "goodsStatisticalSummary" },
      },
      // 设备渠道登录日志
      {
        path: "deviceLoginLog",
        name: "deviceLoginLog",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/deviceLoginLog.vue"
          ),
        meta: { requireAuth: true, name: "渠道登录日志", comp: "deviceLoginLog" },
      },
      // 设备渠道变动统计
      {
        path: "channelChangeStatistics",
        name: "channelChangeStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/channelChangeStatistics.vue"
          ),
        meta: { requireAuth: true, name: "渠道变动统计", comp: "channelChangeStatistics" },
      },
      // 付费留存统计
      {
        path: "payRetainCycleStatistics",
        name: "payRetainCycleStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/payRetainCycleStatistics.vue"
          ),
        meta: { requireAuth: true, name: "付费留存统计", comp: "payRetainCycleStatistics" },
      },
      // 周期数据汇总统计
      {
        path: "cycleStatistics",
        name: "cycleStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/cycleStatistics.vue"
          ),
        meta: { requireAuth: true, name: "周期数据汇总统计", comp: "cycleStatistics" },
      },
      // 第二期
      // 分时段登录统计
      {
        path: "hourLogin",
        name: "hourLogin",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/hourLogin.vue"
          ),
        meta: { requireAuth: true, name: "分时段登录统计", comp: "hourLogin" },
      },
      // 每天登录统计
      {
        path: "loginStatisticsDay",
        name: "loginStatisticsDay",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/loginStatisticsDay.vue"
          ),
        meta: { requireAuth: true, name: "每天登录统计", comp: "loginStatisticsDay" },
      },
      // 流失活跃统计
      {
        path: "lostActiveStatistics",
        name: "lostActiveStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/lostActiveStatistics.vue"
          ),
        meta: { requireAuth: true, name: "流失活跃统计", comp: "lostActiveStatistics" },
      },
      // 用户设备信息
      {
        path: "userDevice",
        name: "userDevice",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/userDevice.vue"
          ),
          meta: { requireAuth: true, name: "用户设备信息", comp: "userDevice" },
      },
      // 充值排行榜
      {
        path: "payTop",
        name: "payTop",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/payTop.vue"
          ),
          meta: { requireAuth: true, name: "充值排行榜", comp: "payTop" },
      },
      // 等级留存统计
      {
        path: "levelStatistics",
        name: "levelStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/levelStatistics.vue"
          ),
          meta: { requireAuth: true, name: "等级留存统计", comp: "levelStatistics" },
      },
      // RFM模型管理
      {
        path: "rfmStatistics",
        name: "rfmStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/rfmStatistics.vue"
          ),
          meta: { requireAuth: true, name: "RFM模型管理", comp: "rfmStatistics" },
      },
      // 首次付费转化率
      {
        path: "firstPayStatistics",
        name: "firstPayStatistics",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cycleStatistics/firstPayStatistics.vue"
          ),
          meta: { requireAuth: true, name: "首次付费转化率", comp: "firstPayStatistics" },
      },
      // 优惠券管理
      // 优惠券
      {
        path: "voucher",
        name: "voucher",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/voucher/voucher.vue"
          ),
        meta: { requireAuth: true, name: "优惠券管理", comp: "voucher" },
      },
      // 优惠券订单列表
      {
        path: "voucherOrder",
        name: "voucherOrder",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/voucher/voucherOrder.vue"
          ),
        meta: { requireAuth: true, name: "订单列表", comp: "voucherOrder" },
      },
      // 登陆日志
      // 日志
      {
        path: "loginLog",
        name: "loginLog",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/log/loginLog.vue"
          ),
        meta: { requireAuth: true, name: "登陆日志", comp: "loginLog" },
      },
      // 员工管理
      // 员工
      {
        path: "staff",
        name: "staff",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/staff/staff.vue"
          ),
        meta: { requireAuth: true, name: "员工管理", comp: "staff" },
      },
      // 主体管理
      {
        path: "mainBody",
        name: "mainBody",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/manage/mainBody.vue"
          ),
        meta: { requireAuth: true, name: "主体管理", comp: "mainBody" },
      },
      // 企业微信聊天记录
      // 私聊
      {
        path: "privateChat",
        name: "privateChat",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/chatMonitoring/privateChat.vue"
          ),
        meta: { requireAuth: true, name: "私聊", comp: "privateChat" },
      },
      // 群聊
      {
        path: "groupChat",
        name: "groupChat",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/chatMonitoring/groupChat.vue"
          ),
        meta: { requireAuth: true, name: "群聊", comp: "groupChat" },
      },
      // sop召回流水
      {
        path: "sopRecall",
        name: "sopRecall",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/chatMonitoring/sopRecall.vue"
          ),
        meta: { requireAuth: true, name: "sop召回流水", comp: "sopRecall" },
      },
      // sop召回流水lc
      {
        path: "sopRecallLC",
        name: "sopRecallLC",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/chatMonitoring/sopRecallLC.vue"
          ),
        meta: { requireAuth: true, name: "sop召回流水(轮虫)", comp: "sopRecallLC" },
      },
      // 新增用户设备
      {
        path: "device",
        name: "device",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/device/device.vue"
          ),
        meta: { requireAuth: true, name: "新增用户设备", comp: "device" },
      },
      // 代币购买
      {
        path: "coinManager",
        name: "coinManager",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/coin/coinManager.vue"
          ),
        meta: { requireAuth: true, name: "代币购买", comp: "coinManager" },
      },
      // 代币订单列表
      {
        path: "coinOrder",
        name: "coinOrder",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/coin/coinOrder.vue"
          ),
        meta: { requireAuth: true, name: "代币订单列表", comp: "coinOrder" },
      },
      // 代币使用详情
      {
        path: "coinLog",
        name: "coinLog",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/coin/coinLog.vue"
          ),
        meta: { requireAuth: true, name: "代币使用详情", comp: "coinLog" },
      },
      // 当日付费详情
      {
        path: "payReport",
        name: "payReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/payReport.vue"
          ),
        meta: { requireAuth: true, name: "当日付费详情", comp: "payReport" },
      },
      // 当日区服详情
      {
        path: "payZoneReport",
        name: "payZoneReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/payZoneReport.vue"
          ),
        meta: { requireAuth: true, name: "当日区服详情", comp: "payZoneReport" },
      },
      // 设备列表
      {
        path: "deviceActivate",
        name: "deviceActivate",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/device/deviceActivate.vue"
          ),
        meta: { requireAuth: true, name: "设备列表", comp: "deviceActivate" },
      },
      // 身份证黑名单
      {
        path: "blackIdNumber",
        name: "blackIdNumber",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/black/blackIdNumber.vue"
          ),
        meta: { requireAuth: true, name: "身份证黑名单", comp: "blackIdNumber" },
      },
      // 广告设备统计
      {
        path: "adDeviceReport",
        name: "adDeviceReport",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/statistics/adDeviceReport.vue"
          ),
        meta: { requireAuth: true, name: "广告设备统计", comp: "adDeviceReport" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  //记住最后一次的访问页面
  if (to.fullPath !== "/") {
    sessionStorage.setItem("lastRoute", to.fullPath);
    sessionStorage.setItem("lastRouteName", to.name);
  }
  if (to.meta.requireAuth) {
    if (sessionStorage.getItem("access_token")) {
      //只有登录成功了，并且有token，才会执行下一步
      next();
    } else {
      next({
        path: "/",
      });
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  const MAGIC = store.state.MAGIC
  if (MAGIC && to.path !== '/') router.push('/home/index')
})
